export default __webpack_public_path__ + "static/media/resting-perchie.7384201c.png";